// src/components/layouts/AuthLayout.js

import React from 'react';
import MetaTags from '../MetaTags';
import HeaderComponent from '../HeaderComponent';
import FooterComponent from '../FooterComponent';
import { Link } from 'react-router-dom';
import logoPath from '../../assets/img/logo_back_1.png';

// 1. IMPORTANT: Make sure this file is named AuthLayout.css (NOT .module.css)
//    and use a standard global import.
import './AuthLayout.css'; 

const AuthLayout = ({ pageTitle, metaDescription, sidebarTitle, subtitle, children, className = '' }) => {
  return (
    // 2. Add the unique parent wrapper div.
    //    All CSS rules below will be prefixed with this class to make them more specific.
    // <div className="auth-page-wrapper"> 
    //   <MetaTags title={pageTitle} description={metaDescription} />
      <div className={`auth-page-wrapper ${className}`}>
      <MetaTags title={pageTitle} description={metaDescription} />
   
      <main className="login_screen_custom">
        <div className="login-container-custom shadow-sm">
          <Link to="/">
            <img src={logoPath} alt="Logo" className="auth-logo" />
          </Link>
          <h2 className="login-title-custom">{sidebarTitle}</h2>
          <p className="subtitle-custom">{subtitle}</p>
          <div className="auth-content">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;